import { Col } from 'reactstrap';
import styled from 'styled-components';

export const StyledCol = styled(Col)`
    margin-bottom: 10px;
`;
